// extracted by mini-css-extract-plugin
export default {"table":"MyTable_table__UsPlD","lastRow":"MyTable_lastRow__nEefb"};